const appointments = [
    {
        "size": "",
        "style": "",
        "class": "",
        "children": [
            {
                "type": "topbar",
                "size": "12",
                "style": "",
                "class": "px-4",
                "title": 'Appointments',
            },
            {
                "type": "tabs",
                "size": "12",
                "style": "",
                "class": "px-4 pt-4",
                "children": [
                    {
                        "title": "Settings",
                        "service": "category",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": false,
                            "activeToggle": false,
                            "deleteButton": false, 
                            "updateSuccessTitle": 'Category Updated!',
                            "updateSuccessMessage": 'Category Updated Successfully!',
                            "updateErrorTitle": 'Category Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                        },
                        "children": [
                            {
                                "type": "descriptionTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "type": "list",
                                    "size": "4",
                                    "style": "",
                                    "class": "p-2",
                                    "empty": true,
                                    "children": [
                                    ]
                                },
                                "form": {
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "pl-4 pt-3",
                                    "form": {
                                        "text": {
                                        "type": 'ckeditor',
                                        "label": 'Page Description',
                                        "placeholder": 'Enter Description',
                                        "required": true,
                                        "info": false,
                                        "character_count": 2000,
                                        "disabled": false,
                                        "class": '',
                                        "size": "12",
                                        "style": ""
                                        },
                                        "hr1": {
                                            "type": 'hr',
                                            "size": "12",
                                        },
                                        "urgent_treatment_centres": {
                                            "type": 'toggle',
                                            "label": 'Urgent Treatment Centres',
                                            "placeholder": '',
                                            "required": false,
                                            "info": true,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "urgent_treatment_centres_title": {
                                            "type": 'text',
                                            "label": 'Title',
                                            "placeholder": 'Enter Title',
                                            "required": true,
                                            "info": true,
                                            "character_count": 250,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "urgent_treatment_centres_list": {
                                            "type": 'checkObjectMultiLocPlaces',
                                            "label": 'Select',
                                            "placeholder": 'Location List',
                                            // "displayOn": 'locations',
                                            // "displayOnValue": 'true',
                                            "hideLabel": true,
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""                                  
                                        },
                                        "hr2": {
                                            "type": 'hr',
                                            "size": "12",
                                        },
                                        "help_us_help_you": {
                                            "type": 'toggle',
                                            "label": 'Help Us Help You',
                                            "placeholder": '',
                                            "required": false,
                                            "info": true,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "hr3": {
                                            "type": 'hr',
                                            "size": "12",
                                        },
                                        "practice_location_check": {
                                            "type": 'checkbox',
                                            "label": 'Related Information',
                                            "placeholder": 'Practice Location',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "pcn_team_check": {
                                            "type": 'checkbox',
                                            "label": '1',
                                            "hideLabel": true,
                                            "placeholder": 'PCN Team',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "gp_and_nurse_availability_check": {
                                            "type": 'checkbox',
                                            "label": '2',
                                            "hideLabel": true,
                                            "placeholder": 'GP & Nurse Availablity',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "when_we_are_closed_check": {
                                            "type": 'checkbox',
                                            "label": '3',
                                            "hideLabel": true,
                                            "placeholder": 'When we are closed',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "contact_us_check": {
                                            "type": 'checkbox',
                                            "label": '4',
                                            "hideLabel": true,
                                            "placeholder": 'Contact Us',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },                                        
                                        "hr4": {
                                            "type": 'hr',
                                            "size": "12",
                                        },
                                    },
                                    "children": [
                                    ]
                                }
                            },                            
                        ]
                    },
                    {
                        "title": "Types",
                        "service": "categoryTypes",
                        "type": "",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": false,
                            "activeToggle": true,
                            "deleteButton": false, 
                            "addNewSuccessTitle": 'Type Added!',
                            "addNewSuccessMessage": 'Type Added Successfully!',
                            "addNewErrorTitle": 'Type Creation Failed!',
                            "addNewErrorMessage": 'Please try again!',
                            "deleteSuccessTitle": 'Type Deleted!',
                            "deleteSuccessMessage": 'Type Deleted Successfully!',
                            "deleteErrorTitle": 'Type Deletion Failed!',
                            "deleteErrorMessage": 'Please try again!',
                            "activeSuccessTitle": 'Type Activated!',
                            "activeSuccessMessage": 'Type Activated Successfully!',
                            "activeErrorTitle": 'Type Activation Failed!',
                            "activeErrorMessage": 'Please try again!',
                            "updateSuccessTitle": 'Type Updated!',
                            "updateSuccessMessage": 'Type Updated Successfully!',
                            "updateErrorTitle": 'Type Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                            "addNewModal": {
                                "title": "Add New Type",
                                "variant": "add",
                                "form": {
                                    "title": {
                                    "type": 'text',
                                    "label": 'Type',
                                    "placeholder": 'Enter Type',
                                    "required": true,
                                    "info": true,
                                    "character_count": 250,
                                    "disabled": false,
                                    "class": '',
                                    "size": "12",
                                    "style": ""
                                    },
                                },
                                "additionalProps": {
                                    "active": true,
                                    "content": "",
                                }
                            }
                        },
                        "children": [
                            {
                                "type": "typesTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "label": "Types",
                                    "type": "typeList",
                                    "info": true,
                                    "size": "4",
                                    "style": "",
                                    "class": "p-0 pt-3 pr-3",
                                    "load_url": "/api/categories/$currentCategoryId/pages",
                                    "draggable": true,
                                    "children": [
                                    ]
                                },
                            "form": {
                                    "title": "Tab Two",
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "pl-4 pt-3",
                                    "submit_url": "/api/pages/$currentPageId",
                                    "form": {
                                        "title": {
                                            "type": 'text',
                                            "label": 'Title',
                                            "placeholder": 'Enter Title',
                                            "required": true,
                                            "info": true,
                                            "character_count": 250,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "content": {
                                            "type": 'ckeditor',
                                            "label": 'Content',
                                            "placeholder": 'Enter Content',
                                            "required": true,
                                            "info": false,
                                            "character_count": 2000,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                            },
                                        // "content": {
                                        //     "type": 'subgroup',
                                        //     "label": 'Sub-groups',
                                        //     "placeholder": 'Enter Subgroup',
                                        //     "required": false,
                                        //     "info": false,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "12",
                                        //     "style": ""
                                        // },
                                        // "address": {
                                        //     "type": 'text',
                                        //     "label": 'Address',
                                        //     "placeholder": 'Enter Address',
                                        //     "required": true,
                                        //     "info": true,
                                        //     "character_count": 250,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "12",
                                        //     "style": ""
                                        // },
                                        // "date": {
                                        //     "type": 'date',
                                        //     "label": 'Date',
                                        //     "placeholder": 'Enter Date',
                                        //     "required": true,
                                        //     "info": true,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "12",
                                        //     "style": ""
                                        // },
                                    },
                                    "children": [
                                    ]
                                }
                            },

                        ]
                    },
                    {
                        "title": "FAQ",
                        "service": "pages",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": true,
                            "activeToggle": true,
                            "deleteButton": true, 
                            "addNewSuccessTitle": 'Topic Added!',
                            "addNewSuccessMessage": 'Topic Added Successfully!',
                            "addNewErrorTitle": 'Topic Creation Failed!',
                            "addNewErrorMessage": 'Please try again!',
                            "deleteSuccessTitle": 'Topic Deleted!',
                            "deleteSuccessMessage": 'Topic Deleted Successfully!',
                            "deleteErrorTitle": 'Topic Deletion Failed!',
                            "deleteErrorMessage": 'Please try again!',
                            "activeSuccessTitle": 'Topic Activated!',
                            "activeSuccessMessage": 'Topic Activated Successfully!',
                            "activeErrorTitle": 'Topic Activation Failed!',
                            "activeErrorMessage": 'Please try again!',
                            "updateSuccessTitle": 'Topic Updated!',
                            "updateSuccessMessage": 'Topic Updated Successfully!',
                            "updateErrorTitle": 'Topic Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                            "addNewModal": {
                                "title": "Add New FAQ",
                                "type": "page",
                                "variant": "add",
                                "submit_url": "/api/categories/$currentCategoryId/pages",
                                "form": {
                                    "title": {
                                    "type": 'text',
                                    "label": 'Question',
                                    "placeholder": 'Enter Question',
                                    "required": true,
                                    "info": true,
                                    "character_count": 250,
                                    "disabled": false,
                                    "class": '',
                                    "size": "12",
                                    "style": ""
                                    },
                                },
                                "additionalProps": {
                                    "address": '',
                                    "regular_hours": [{"id":1,"title":"Monday","status":[{"name":"Closed","value":false},{"name":"Interim Closure","value":false}],"opening_time":"08:00","closing_time":"18:30","second_opening_time":"00:00","second_closing_time":"00:00"},{"id":2,"title":"Tuesday","status":[{"name":"Closed","value":false},{"name":"Interim Closure","value":false}],"opening_time":"08:00","closing_time":"18:30","second_opening_time":"00:00","second_closing_time":"00:00"},{"id":3,"title":"Wednesday","status":[{"name":"Closed","value":false},{"name":"Interim Closure","value":false}],"opening_time":"08:00","closing_time":"18:30","second_opening_time":"00:00","second_closing_time":"00:00"},{"id":4,"title":"Thursday","status":[{"name":"Closed","value":false},{"name":"Interim Closure","value":false}],"opening_time":"08:00","closing_time":"18:30","second_opening_time":"00:00","second_closing_time":"00:00"},{"id":5,"title":"Friday","status":[{"name":"Closed","value":false},{"name":"Interim Closure","value":false}],"opening_time":"08:00","closing_time":"18:30","second_opening_time":"00:00","second_closing_time":"00:00"},{"id":6,"title":"Saturday","status":[{"name":"Closed","value":true},{"name":"Interim Closure","value":false}],"opening_time":"08:00","closing_time":"18:30","second_opening_time":"00:00","second_closing_time":"00:00"},{"id":7,"title":"Sunday","status":[{"name":"Closed","value":true},{"name":"Interim Closure","value":false}],"opening_time":"08:00","closing_time":"18:30","second_opening_time":"00:00","second_closing_time":"00:00"}]
                                }
                            },
                        },
                        "children": [
                            {
                                "type": "patientGroupTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "label": "Questions",
                                    "type": "list",
                                    "info": true,
                                    "size": "4",
                                    "style": "",
                                    "class": "p-0 pt-3 pr-3",
                                    "load_url": "/api/categories/$currentCategoryId/pages",
                                    "draggable": true,
                                    "children": [
                                    ]
                                },
                                "form": {
                                    "title": "Tab Two",
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "pl-4 pt-3",
                                    "form": {
                                        "title": {
                                            "type": 'text',
                                            "label": 'Question',
                                            "placeholder": 'Enter Question',
                                            "required": true,
                                            "info": false,
                                            "character_count": 250,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "address": {
                                            "type": 'ckeditor',
                                            "label": 'Answer',
                                            "placeholder": 'Enter Answer',
                                            "required": true,
                                            "info": false,
                                            "character_count": 2000,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                    },
                                    "children": [
                                    ]
                                }
                            }
                            
                            
                        ]
                    },
                ]
            }
        ]
    }
]

export { appointments };